module.exports = __webpack_public_path__ + "static/coloured-logo-7de75536355642b44706792876355ebf.png";